import ComponentTasksTable from './components/component-tasks-table/ComponentTasksTable';

const ComponentTasksTab = (): JSX.Element => {
  return (
    <div className='flex flex-column'>
      <ComponentTasksTable />
    </div>
  );
};

export default ComponentTasksTab;
